import React from "react";

const TimeSeriesForecasting = () => {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center">
      <h1 className="text-5xl font-bold mb-8">Time Series Forecasting</h1>
      <p className="text-gray-400 max-w-2xl text-center">
        Use AI to forecast future trends based on historical data. Ideal for stock prediction, sales forecasting, and more.
      </p>
      <textarea
        className="mt-4 w-full max-w-2xl bg-gray-800 text-white p-4 rounded-lg"
        rows={6}
        placeholder="Paste your time-series data here..."
      ></textarea>
      <button className="mt-4 px-6 py-3 bg-gradient-to-r from-green-400 to-yellow-400 text-black font-bold rounded-lg shadow-lg">
        Forecast Trends
      </button>
    </div>
  );
};

export default TimeSeriesForecasting;